import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
    align-items: center;
    background-color: #f5f5f5;
    border: none;
    border-radius: 0;
    cursor: pointer;
    display: flex;
    font-family: 'Red Hat Display', sans-serif;
    font-size: 1.125rem;
    justify-content: center;
    padding: 0.75rem 1rem 0.75rem 1rem;
    width: 100%;

    &::after {
        content: '';
        display: inline-block;
        background: url(/assets/images/filter.svg) no-repeat;
        width: 19px;
        height: 19px;
        margin: 3px 0 0 12px;
        transition: all 0.2s ease-in-out;
    }
`;

const FilterButton = ({ onClick }) => <Button onClick={onClick}>Filter Results</Button>;

FilterButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default FilterButton;
